module.exports = __webpack_public_path__ + "static/r14-66ce9d5b3ebdd8d27758eb35c28d0e73.jpg";